module.exports = __webpack_public_path__ + "static/media/CPS_long.71da57ec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/CPS_long.png
// module id = 2021
// module chunks = 0